import { useQuery } from '@tanstack/react-query';
import { listFileTags } from 'services/fileManager/fileManagerServices';
import { queryKeys } from 'hooks/config/queryClient';

async function fetchFileTags(caseId) {
  const response = await listFileTags(caseId || '', true);
  return response?.data?.['file-tags'] ?? [];
}

export function useFileTagsQuery({ caseId = '', enabled = true } = {}) {
  const queryKey = queryKeys.fileManager.tags(caseId);

  const {
    data: fullTags = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey,
    queryFn: () => fetchFileTags(caseId),
    enabled,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  const getFileTags = refetch;

  return {
    getFileTags,
    fullTags,
    isLoading,
    refetch,
  };
}

export default useFileTagsQuery;
